module.exports = require("core-js/library/fn/parse-float");


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime-corejs2/core-js/parse-float.js
// module id = 39
// module chunks = 101